/**
 * Converts an ISO date string to a local date string in the format 'YYYY-MM-DD'.
 * 
 * @param {string} isoString - The ISO date string to convert.
 * @returns {string} - The local date string in the format 'YYYY-MM-DD'.
 * 
 * @example
 * const isoString = '2025-04-27T04:16:05.620Z';
 * const localDateString = isoToLocalDateString(isoString); // local browser timezone = US Pacific
 * console.log(localDateString); // '2025-04-26'
 */
export const isoToLocalDateString = (isoString) => {
  const date = new Date(isoString); // Parse ISO string
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based
  const day = date.getDate().toString().padStart(2, '0');

  return `${year}-${month}-${day}`;
}

/**
 * Converts a date string in the format 'YYYY-MM-DD' to a Date object with the current time.
 * 
 * @param {string} dateString - The date string in the format 'YYYY-MM-DD'.
 * @returns {Date} - A Date object with the specified date and the current time.
 */
export const dateWithCurrentTime = (dateString) => {
  const now = new Date();
  const [year, month, day] = dateString.split('-').map(Number);

  return new Date(
    year,
    month - 1,    // Month is 0-indexed
    day,
    now.getHours(),
    now.getMinutes(),
    now.getSeconds(),
    now.getMilliseconds()
  );
};

/**
 * Returns the most recent Monday from the given date.
 * If no date is provided, it defaults to the current date.
 */
export const getMostRecentMonday = (date = new Date()) => {
  const dayOfDate = date.getDay();
  const daysSinceMonday = (dayOfDate + 6) % 7; // getDay() returns 0 for Sunday

  return new Date(date.getFullYear(), date.getMonth(), date.getDate() - daysSinceMonday);
}
